import { render, staticRenderFns } from "./class-record.vue?vue&type=template&id=1e489ba2&scoped=true"
import script from "./class-record.vue?vue&type=script&lang=js"
export * from "./class-record.vue?vue&type=script&lang=js"
import style0 from "./class-record.vue?vue&type=style&index=0&id=1e489ba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e489ba2",
  null
  
)

export default component.exports